import { ActionType } from '../../models/Action';
export class StudioVersionService {
    static $inject = ['BuilderAiAgentService'];
    constructor(BuilderAiAgentService) {
        this.BuilderAiAgentService = BuilderAiAgentService;
    }
    updateAiBlockVersion(states) {
        for (const state of states) {
            const action = state.$enteringCustomActions
                ?.find(action => action.type === ActionType.ForwardToAgent);
            if (action?.settings) {
                action.settings.version = this.BuilderAiAgentService.getAgentBlockLatestVersion();
            }
        }
    }
}
